import React, { Component } from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import { isApiResponse, isReportAccess } from '../helpers/utils.js';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { css } from "@emotion/core";

import LastRefresh from './LastRefresh.jsx';
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;

class CSMPerformanceReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            error: null,
            sortKey: null,
            sortDir: 'asc',
        };
    }

    handleSort = (key) => {
        this.setState(prevState => ({
            sortKey: key,
            sortDir: prevState.sortKey === key && prevState.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    }

    // All CSM rows come back in one response, so sorting is done client-side.
    getSortedData(data) {
        const { sortKey, sortDir } = this.state;
        if (!sortKey) return data;
        return [...data].sort((a, b) => {
            const av = a[sortKey];
            const bv = b[sortKey];
            const an = parseFloat(av);
            const bn = parseFloat(bv);
            if (!isNaN(an) && !isNaN(bn)) {
                return sortDir === 'asc' ? an - bn : bn - an;
            }
            const as = (av || '').toString().toLowerCase();
            const bs = (bv || '').toString().toLowerCase();
            if (as < bs) return sortDir === 'asc' ? -1 : 1;
            if (as > bs) return sortDir === 'asc' ? 1 : -1;
            return 0;
        });
    }

    renderSortArrow(key) {
        const { sortKey, sortDir } = this.state;
        if (sortKey !== key) return <span style={{color: '#ccc', marginLeft: '4px'}}>⇅</span>;
        return <span style={{marginLeft: '4px'}}>{sortDir === 'asc' ? '▲' : '▼'}</span>;
    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        //isReportAccess(AllAccessPermissions, "csm_performance_report");

        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
            email:decoded.email,
            encodedEmail: btoa(decoded.email)
        });
    }

    componentDidMount() {
        this.getMarketBookUrl();
        this.getCsmPerformanceReport();
    }

    getMarketBookUrl() {
        axios.get(config.get('API_URL') + "/filters/get-market-book-url", {
            headers: { Authorization: localStorage.usertoken }
        })
        .then(response => {
            this.setState({ marketBookUrl: response.data.url });
        })
        .catch(err => {
            console.error("Market book URL fetch error:", err);
        });
    }

    getCsmPerformanceReport() {
        this.setState({ loading: true });
        isApiResponse(false);

        axios.get(config.get('API_URL') + "/summaryReport/get_csm_performance_report", {
            headers: { Authorization: localStorage.usertoken }
        })
        .then(response => {
            isApiResponse(true);
            if (response.data && response.data.data) {
                this.setState({
                    data: response.data.data,
                    loading: false,
                    error: null,
                });
            }
        })
        .catch(error => {
            isApiResponse(true);
            this.setState({
                loading: false,
                error: "Failed to load data"
            });
            console.error("CSM Report API Error:", error);
        });
    }

    formatNumber(val) {
        if (val === null || val === undefined) return '-';
        return Number(val).toLocaleString('en-IN');
    }

    handleCsmClick = (csm) => {
        if (!csm) return;
        this.props.history.push({
            pathname: "/admin/csm-performance-drilldown",
            search: `?csm=${encodeURIComponent(csm)}`,
        });
    }

    render() {
        const { loading, error, data } = this.state;

        if (loading) {
            return (
                <div className="content-invoice">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="header">
                                        <h4 className="title">CSM Performance Report</h4>
                                    </div>
                                    <div className="content">
                                        <BeatLoader css={override} size={15} color={"#51bcda"} loading={loading} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="content-invoice">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="header">
                                        <h4 className="title">CSM Performance Report</h4>
                                    </div>
                                    <div className="content">
                                        <div className="alert alert-danger">{error}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">CSM Performance Report</h4>
                                        <LastRefresh />
                                    </div>
                                </div>

                                <div className="col-md-3" style={{ paddingTop: '15px', textAlign: 'right' }}>
                                    <a
                                        href={`${this.state.marketBookUrl}?email=${this.state.encodedEmail}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-primary btn-sm"
                                        style={{ backgroundColor: '#5e35b1', borderColor: '#5e35b1' }}
                                    >
                                        <i className="fa fa-external-link"></i>&nbsp; Unipay Market Book
                                    </a>
                                </div>
                                <div className="clearfix"></div>

                                <div className="content">
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table className="table table-striped table-hover">
                                            <thead>
                                                <tr style={{ backgroundColor: '#5e35b1', color: 'white' }}>
                                                    <th rowSpan={2} style={{ cursor: 'pointer', userSelect: 'none' }}
                                                        onClick={() => this.handleSort('csm')}>
                                                        CSM{this.renderSortArrow('csm')}
                                                    </th>
                                                    <th colSpan={2} style={{ textAlign: 'center', borderLeft: '1px solid rgba(255,255,255,0.3)' }}>
                                                        Transactable UTIDs
                                                    </th>
                                                    <th colSpan={2} style={{ textAlign: 'center', borderLeft: '1px solid rgba(255,255,255,0.3)' }}>
                                                        Transacting Stores
                                                    </th>
                                                </tr>
                                                <tr style={{ backgroundColor: '#5e35b1', color: 'white' }}>
                                                    <th style={{ borderLeft: '1px solid rgba(255,255,255,0.3)', cursor: 'pointer', userSelect: 'none' }}
                                                        onClick={() => this.handleSort('transactable_utids_mtd')}>
                                                        MTD Achievement{this.renderSortArrow('transactable_utids_mtd')}
                                                    </th>
                                                    <th style={{ cursor: 'pointer', userSelect: 'none' }}
                                                        onClick={() => this.handleSort('transactable_utids_lmtd')}>
                                                        LMTD Achievement{this.renderSortArrow('transactable_utids_lmtd')}
                                                    </th>
                                                    <th style={{ borderLeft: '1px solid rgba(255,255,255,0.3)', cursor: 'pointer', userSelect: 'none' }}
                                                        onClick={() => this.handleSort('transacting_stores_mtd')}>
                                                        MTD Achievement{this.renderSortArrow('transacting_stores_mtd')}
                                                    </th>
                                                    <th style={{ cursor: 'pointer', userSelect: 'none' }}
                                                        onClick={() => this.handleSort('transacting_stores_lmtd')}>
                                                        LMTD Achievement{this.renderSortArrow('transacting_stores_lmtd')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={5} style={{ textAlign: 'center' }}>No data available</td>
                                                    </tr>
                                                ) : (
                                                    this.getSortedData(data).map((row, idx) => (
                                                        <tr key={idx}>
                                                            <td>
                                                                <a
                                                                    href="#"
                                                                    onClick={(e) => { e.preventDefault(); this.handleCsmClick(row.csm); }}
                                                                    style={{ color: '#5e35b1', textDecoration: 'underline', cursor: 'pointer' }}
                                                                >
                                                                    <strong>{row.csm}</strong>
                                                                </a>
                                                            </td>
                                                            <td>{this.formatNumber(row.transactable_utids_mtd)}</td>
                                                            <td>{this.formatNumber(row.transactable_utids_lmtd)}</td>
                                                            <td>{this.formatNumber(row.transacting_stores_mtd)}</td>
                                                            <td>{this.formatNumber(row.transacting_stores_lmtd)}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="footer">
                                    <div className="stats">
                                        <i className="fa fa-info-circle"></i>
                                        Total Records: {data.length}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => { dispatch({ type: 'change_menu', payload: name }) }
    }
}

export default withRouter(connect(null, mapDispatchToProps)(CSMPerformanceReport));